import React, { useEffect } from 'react';
import TextFX from 'txt-fx';

const Item = ({ item, onHoverStart, onHoverEnd }) => {

  useEffect(() => {
    const title = document.querySelectorAll('.card');
    const textFX = new TextFX.Replacer();
    title.forEach((item) => {
      textFX.replace(item, 100, true);
    });
  }, []);

  useEffect(() => {
    let square = document.querySelector('.square');
    const centerX = window.innerWidth / 2 - square.offsetWidth / 2;
    const centerY = window.innerHeight / 2 - square.offsetHeight / 2;
    square.style.left = `${centerX}px`;
    square.style.top = `${centerY}px`;
  }, []);

  function moveSquare(e) {
    let square = document.querySelector('.square');
    const squareWidth = square.offsetWidth;
    const squareHeight = square.offsetHeight;
    const cursorX = e.clientX;
    const cursorY = e.clientY;
    let newLeft = Math.min(Math.max(cursorX - squareWidth / 2, 0), window.innerWidth - squareWidth);
    let newTop = Math.min(Math.max(cursorY - squareHeight / 2, 0), window.innerHeight - squareHeight);
    square.style.left = `${newLeft}px`;
    square.style.top = `${newTop}px`;
    onHoverStart();
  }

  function focusSquare(e) {
    let square = document.querySelector('.square');
    let rect = e.target.getBoundingClientRect();
    square.style.left = rect.left + 'px';
    square.style.top = rect.top + 'px';
    onHoverStart();
  }

  function leaveSquare() {
    onHoverEnd();
  }

  return (
    <a
      className="card"
      href={item.slug}
      data-img={item.img}
      onMouseEnter={moveSquare}
      onFocus={focusSquare}
      onMouseLeave={leaveSquare}
      onBlur={leaveSquare}
      style={{
        display: 'inline-block',
        overflowWrap: 'anywhere',
        textDecoration: 'none',
        color: 'orange',
        padding: '0',
        margin: '0',
        fontSize: '4rem',
      }}>
      {item.title}
    </a>
  );
};

export default Item;
